export const serviciosSistemas = {
  background: "linear-gradient(135deg, #f4f7f5, #e8efea)",

  servicios: [
    {
      id: "ordenar",
      nombre: "ORDENAR",
      precio: "Desde $150.000",
      descripcion:
        "Transformamos información desordenada en datos organizados, fáciles de encontrar y utilizar.",

      color: "#3d6b50",

      boton: "QUIERO ORDENAR",

      items: [
        "Organización de archivos Excel",
        "Limpieza y normalización de datos",
        "Carga y actualización de productos",
        "Organización de imágenes",
        "Relación productos ↔ imágenes",
        "Eliminación de información duplicada",
        "Estructuración de datos",
        "Preparación para futuras automatizaciones",
      ],
    },

    {
      id: "digitalizar",
      nombre: "DIGITALIZAR",
      precio: "Desde $300.000",
      descripcion:
        "Convertimos procesos que hoy dependen de Excel y tareas manuales en sistemas digitales.",

      color: "#256b72",

      destacado: true,

      badge: "SOLUCIÓN PRINCIPAL",

      boton: "QUIERO DIGITALIZAR",

      items: [
        "Diseño de base de datos",
        "Migración de información desde Excel",
        "Gestión de productos",
        "Gestión de imágenes",
        "Sistema web personalizado",
        "Panel privado",
        "ABM de información",
        "Consultas y búsquedas",
        "Usuarios y permisos",
        "Firebase / base de datos",
      ],
    },

    {
      id: "automatizar",
      nombre: "AUTOMATIZAR",
      precio: "Desde $450.000",
      descripcion:
        "Conectamos tus datos y sistemas para reducir tareas repetitivas y recuperar tiempo.",

      color: "#5b4778",

      boton: "QUIERO AUTOMATIZAR",

      items: [
        "Automatización de tareas repetitivas",
        "Integración entre sistemas",
        "Procesamiento automático de datos",
        "Carga masiva de información",
        "Generación de reportes",
        "Exportación Excel / PDF",
        "Notificaciones automáticas",
        "Integración con WhatsApp",
        "Paneles y estadísticas",
        "Mejoras continuas del sistema",
      ],
    },
  ],
};